<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 12:26:48
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-11-28 17:51:20
-->
<template>
  <div class="card-wrapper">
    <div>
      <div class="top">
        <div class="avatar">
          <van-image
            @click="handlePersonal(rowData.userId)"
            round
            width="1rem"
            height="1rem"
            :src="rowData.userIconUrl"
          />
          <FansPendant v-if="rowData.userId" :userId="rowData.userId"/>
        </div>
        <div class="info">
          <div class="name" @click="handlePersonal(rowData.userId)">
            <span>{{rowData.userName}}
              <span v-if="rowData.organizationFullName" class="inner-box" style="font-size:12px;color:#606266;">{{formatOrg(rowData.organizationFullName)}}</span>
            </span>
          </div>
          <div class="org">
            <!-- <span v-if="rowData.organizationFullName" class="inner-box" style="max-width:240px;">{{formatOrg(rowData.organizationFullName)}}</span> -->
            <template v-if="rowData.type !== 1">
              <span class="time">{{rowData.createTime}}</span>
            </template>
            <template v-else>
              <span class="time" v-if="rowData.changeTime && timeField === 'changeTime'">{{rowData.changeTime ? `${getDateDiff(rowData.changeTime)}更新` : `${getDateDiff(rowData.createTime)}发布`}}</span>
              <span class="time" v-else>{{`${getDateDiff(rowData.createTime)}发布`}}</span>
            </template>
            <span>
                <van-icon name="eye-o" />
                {{rowData.viewNum}}
              </span>
              
          </div>
        </div>
      </div>
      <div class="title" v-if="rowData.type !== 1">
        <!-- <img v-if="rowData.orderType === 80" src="https://storage.jd.com/iast-agent/hotIcon.png" alt="" class="hot"> -->
        <!-- <span v-if="rowData.refinedFlag" class="boutique">精</span> -->
        <span v-if="rowData.orderType === 80" class="sd-hot-article-tag">置顶</span>
        <van-icon v-if="rowData.viewNum > 499" name="fire" color="#f53f3f"></van-icon>
        <div
          @click="handleLinkDetail"
          class="inner-box">
          {{rowData.title}}
        </div>
      </div>
      <div @click="handleLinkDetail" class="middle">
        <div class="content">
          {{rowData.info || rowData.contentText}}
        </div>
        <van-image
          v-if="rowData.firstImgUrl && rowData.type !== 1"
          :src="rowData.firstImgUrl"
          lazy-load
          class="first-img"
        >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div v-if="imageList.length"  class="image-list">
          <div v-for="(item, index) in imageList" :key="item">
            <van-image :src="item" lazy-load class="image-item" @click.stop="() => preViewImage(index)"/>
          </div>
        </div>
        <div v-if="rowData.voteId > 0 && rowData.voteInfo" class="vote" @click.stop="() => {}">
          <div class="vote-header">
            <div>{{rowData.voteInfo.name}}</div>
            <span>{{rowData.voteInfo.totalPeople}}人已参与 {{ rowData.voteInfo.status === 1 ? '已结束' : `距离结束还有${rowData.voteInfo.validityDay}天` }}</span>
          </div>
          <div class="vote-finshed" v-if="(rowData.voteInfo.userVoteOptions && rowData.voteInfo.userVoteOptions.length) || rowData.voteInfo.status === 1">
            <div
              v-for="item in rowData.voteInfo.options.slice(0, 3)"
              :key="item.id"
              class="vote-option"
            >
              <div
                class="vote-checked-bg"
                :style="{
                  width: getVoteWidth(item),
                  backgroundColor: rowData.voteInfo.userVoteOptions.includes(item.id)
                    ? '#50b7ff'
                    : '#999aaa',
                }"
              ></div>
              <div>
                {{item.name}}
                <img src="./../../../assets/duigou.png" class="vote-selected" v-if="rowData.voteInfo.userVoteOptions.includes(item.id)"/>
              </div>
              <span :style="{
                        color: rowData.voteInfo.userVoteOptions.includes(item.id) ? '#50b7ff' : '#999aaa',
                      }">{{item.totalVote}}票</span>
            </div>
          </div>
          <div class="vote-pending" v-else>
            <template v-if="rowData.voteInfo.multi === 1">
              <van-checkbox-group v-model="voteResult">
                  <van-checkbox icon-size="14px" class="vote-checkbox" shape="square" v-for="option in rowData.voteInfo.options.slice(0, 3)" :key="option.id" :name="option.id">{{option.name}}</van-checkbox>
              </van-checkbox-group>
            </template>
            <template v-else>
              <van-radio-group v-model="voteValue">
                <van-radio icon-size="14px" class="vote-checkbox" v-for="option in rowData.voteInfo.options.slice(0, 3)" :key="option.id" :name="option.id">{{option.name}}</van-radio>
              </van-radio-group>
            </template>
          </div>
          <div v-if="rowData.voteInfo && rowData.voteInfo.options && rowData.voteInfo.options.length > 3" class="vote-option-more" @click="handleLinkDetail">查看更多选项</div>
          <div v-if="(!rowData.voteInfo.userVoteOptions || !rowData.voteInfo.userVoteOptions.length) && rowData.voteInfo.status === 0" class="vote-operate">
            <div @click="handleVote">投票</div>
          </div>
        </div>

      </div>
      <div v-if="deptName && showDeptSource" class="dept-source">来自部门圈（{{deptName}}）</div>
    </div>
    <van-divider />
    <Comment :rowData="rowData" @refresh="handleRefresh" />
    <div v-if="rowData.type !== 0 && hotReplyList.length" class="hot-reply">
      <div class="hot-reply-list">
        <div
        v-for="hotReply in hotReplyList"
        :key="hotReply.id">{{hotReply.userRealName}}：{{hotReply.content}}</div>
      </div>
      <div class="hot-reply-btn" @click="handleLinkDetail">查看更多评论 ></div>
    </div>
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant'
import Comment from './comment.vue'
import api from '../../../api'
import { getDateDiff } from '../../../utils/lib';
import FansPendant from '../../../components/fansPendant.vue';

export default {
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    timeField: {
      type: String,
      default: 'changeTime'
    },
    showDeptSource: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Comment,
    FansPendant
  },
  data() {
    return {
      showUp: false,
      showPop: false,
      message: '',
      btnLoading: false,
      voteResult: [],
      voteValue: undefined,
      getDateDiff,
    }
  },
  computed: {
    imageList() {
      if (!this.rowData?.contentText || this.rowData?.type !== 1) return [];
      const imgReg = /<img.*?(?:>|\/>)/gi;
      // eslint-disable-next-line no-useless-escape
      const srcReg = /(http|https):\/\/[\'\"]?([^\'\"]*)[\'\"]?/i;
      // 图片链接
      const imgList = (this.rowData.contentText.match(imgReg) || []).map((o) => {
        let imgLink = o.match(srcReg);
        if (imgLink && imgLink.length) {
          let item = imgLink[0];
          return item.substring(0, item.length - 1);
        }
        return null;
      });
      return imgList;
    },
    hotReplyList() {
      const list = this.rowData?.hotReplyList?.map((item) => {
        return {
          ...item,
          content: this.getReplyContent(item.content)
        }
      })
      return list || []
    },
    deptName() {
      const dept = this.rowData?.forums?.find((item) => item.orgCode && item.orgCode !== '0');
      const nameList = dept?.name?.split('-') || [];
      return dept?.name === '集团T-PaaS' ? dept?.name : nameList[nameList.length - 1] || ''
    }
  },
  methods: {
    getReplyContent(_content) {
      const newContent = _content?.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, '[图片]');
      const text = newContent?.replace(/<[^<>]+>/g, '');
      return text;
    },
    preViewImage(index) {
      ImagePreview(this.imageList, index)
    },
    async handleVote() {
      const { data, code } = await api.vote({
        voteId: this.rowData.voteId,
        postId: this.rowData.id,
        optionId: this.rowData.voteInfo.multi === 1 ? [...this.voteResult] : [this.voteValue]
      })
      if (code === 200) {
        Toast.success('投票成功')
        this.$emit('refresh', { ...this.rowData, voteInfo: { ...data } }, 'vote')
      }
    },
    getVoteWidth(option) {
      const { totalVote } = option;
      return Math.abs(Number((totalVote / this.rowData.voteInfo.totalPeople) * 100).toFixed(0)) + '%';
    },
    handlePreview(url) {
      ImagePreview([url])
    },
    handleLinkDetail() {
      if (+this.rowData.type === 1) {
        this.$router.push({ name: 'bbsDetail', params: { id: this.rowData.id } })
        return;
      }
      this.$router.push({ name: 'articleDetail', params: { id: this.rowData.id } })
    },
    handleRefresh(val, type) {
      this.$emit('refresh', val, type)
    },
    formatOrg(val) {
      if (val) {
        let ary = val.split('-')
        let filterAry = ary.slice(1, 3)
        return filterAry.join('-')
      }
    },
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.dept-source {
  color: #606266;
  // margin-left: 16px;
  text-align: right;
}
.image-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}
.image-item {
  width: 100%;
  max-height: 150px;
  /deep/.van-image__img {
    max-height: 150px;
    object-fit: contain;
  } 
}
.vote-selected {
  height: 13px;
  width: 13px;
  margin-left: 8px;
}
.vote {
  text-align: left;
  border: 1px solid #efeff2;
  padding: 8px;
  border-radius: 4px;
  &-header {
    & > div {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    & > span {
      color: #606266;
      font-size: 12px;
    }
  }
  &-option {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 8px 4px;
    padding: 8px 16px;
    background-color: #fbfbfb;
    border-radius: 4px;
    font-size: 14px;
  }
  &-option-more {
    margin: 8px 4px;
    padding: 8px 16px;
    color: #2695f1;
  }
  &-checked-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0.2;
  }
  &-checkbox {
    font-size: 14px;
    // display: block;
    // & > div {
      margin: 8px 4px;
      padding: 8px 16px;
      background-color: #fbfbfb;
      border-radius: 4px;
      font-size: 14px;
    // }
  }
  &-operate {
    text-align: center;
    padding: 8px 16px 0px 16px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      padding: 2px 16px;
      color: #fff;
      background-color: #2695f1;
      border-radius: 50px;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        background-color: #50b7ff;
      }
    }
  }

}
.sd-hot-article-tag {
  height: 16px;
  margin-right: 4px;
  padding: 0 8px;
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
  box-sizing: border-box;
  line-height: 16px;
  background: #ef5858;
  border-radius: 4px;
  display: inline-block;
}
/deep/ .van-divider {
  margin: 2px 0;
}
.card-wrapper {
  margin: 8px;
  // margin-top: 10px;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  // line-height: 1;
}
.inner-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.org {
  font-size: 14px;
  width: 100%;
  display: inline-flex;
  font-size:12px;
  color:#606266;
}
.name {
  color: #232930;
  text-align: left;
}
.info {
  margin-left: 6px;
  color: #606266;
  display: flex;
  flex: 1;
  font-size: 14px;
  flex-direction: column;
  align-items: self-start;
}
.middle {
  margin-top: 4px;
  .content {
    text-align: left;
    margin-bottom: 8px;
    font-size: 14px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
}
.bottom {
  display: flex;
  .operate-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    > span {
      font-size: 14px;
      margin-left: 5px;
    }
  }
  .up {
    color: #2695F1;
    font-weight: 500;
  }
  .unUp {
    color: #606266;
    font-weight: 400;
  }
}
.first-img {
  width: 100%;
  height: 100px;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f2f5;
  /deep/ img {
    height: auto!important;
  }
}
.err-tip {
  font-size: 14px;
  color: #C9CFD5;
}
.boutique {
  width: 24px;
  height: 24px;
  margin-right: 4px;
  color: #eb6105;
  font-size: 14px;
  text-align: center;
  background-color: #f3db8b;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hot {
  height: 30px;
  width: 14px;
  margin-right: 5px;
  object-fit: cover;
}
.time {
  margin-right: 20px;
}
.hot-reply {
  margin-top: 8px;
  text-align: left;
}
.hot-reply-list {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #939393;
}
.hot-reply-btn {
  color: #2695F1;
}
.avatar {
  flex-shrink: 0;
  position: relative;
}
</style>

